import ua from './translations/ua';
import en from './translations/en';
export default {
  ua,
  en
};